// extracted by extract-css-chunks-webpack-plugin
module.exports = {"recommend":"recommend-2g6Qhro_","title":"title-AAL76c5i","list_box":"list_box-17th0dsU","more":"more-JF8_m7Vo"};